import type { PIIString } from '@trello/privacy';

import { useMemberUsernameToMemberIdQuery } from './MemberUsernameToMemberIdQuery.generated';

export const useUsernameToQueryMemberId = (username: PIIString) => {
  const { data, loading } = useMemberUsernameToMemberIdQuery({
    waitOn: ['None'],
    skip: username === null,
    variables: {
      username,
    },
  });

  return { memberId: data?.memberIdFromUsername?.id, loading };
};
